function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  x1: "47.178%",
  x2: "44.715%",
  y1: "55.278%",
  y2: "13.974%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F9F9F9",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F9F9F9"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M1 0h1920v723H1z"
}), React.createElement("path", {
  fill: "url(#a)",
  transform: "matrix(-1 0 0 1 713 0)",
  d: "M713 49L0 362.455V620h713z"
}));

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 1921,
    height: 723
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOTIxIiBoZWlnaHQ9IjcyMyIgdmlld0JveD0iMCAwIDE5MjEgNzIzIj4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iYmFja2dyb3VuZC1ncmV5LXRyaWFuZ2xlLXNpbmdsZS1hIiB4MT0iNDcuMTc4JSIgeDI9IjQ0LjcxNSUiIHkxPSI1NS4yNzglIiB5Mj0iMTMuOTc0JSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNGOUY5RjkiIHN0b3Atb3BhY2l0eT0iMCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNGOUY5RjkiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTkyMCIgaGVpZ2h0PSI3MjMiIHg9IjEiIGZpbGw9IiNGRkYiLz4KICAgIDxwb2x5Z29uIGZpbGw9InVybCgjYmFja2dyb3VuZC1ncmV5LXRyaWFuZ2xlLXNpbmdsZS1hKSIgcG9pbnRzPSI3MTMgNDkgMCAzNjIuNDU1IDAgNjIwIDcxMyA2MjAiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDcxMyAwKSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgComponent as ReactComponent };